<div class="grid grid-cols-1 lg:grid-cols-2">
  <div class="order-2 lg:order-1">
    <div class="flex flex-col overflow-y-auto bg-gray-50 lg:aspect-[650/833]">
      <div
        class="sticky top-0 bg-gray-50 px-8 pt-8 pb-4 xl:px-16 xl:pt-16 xl:pb-8">
        <h2 class="relative text-5xl uppercase">
          @if (shouldShowStatusInfo()) {
            <span class="absolute ml-3 -translate-x-8 -translate-y-8 text-2xl">
              @if (isPrivate()) {
                <app-icon
                  [icon]="Icon.LockFill"
                  pTooltip="Marka prywatna" />
              }

              @if (isPublic()) {
                <app-icon
                  [icon]="Icon.UnlockFill"
                  pTooltip="Marka publiczna" />
              }

              @if (isDraft()) {
                <app-icon
                  [icon]="Icon.Pencil"
                  pTooltip="Szkic" />
              }
            </span>
          }

          <span>{{ name() }}</span>
        </h2>
        <h3 class="text-2xl font-normal">o marce</h3>
      </div>

      <div class="px-8 xl:px-16">
        <div class="text-sm">
          @if (isNotNil(description())) {
            <app-summernote-html-preview [html]="description()!" />
          }
        </div>
      </div>

      <div class="sticky -bottom-px mt-auto bg-gray-50 pt-8 xl:pt-16">
        <div class="bg-black px-8 py-6 text-white lg:px-16">
          <h3 class="text-2xl font-normal">poznaj bliżej markę</h3>

          <div class="flex gap-4">
            @if (homeUrl(); as homeUrl) {
              <app-external-link [link]="homeUrl!">
                <app-brand-social-media-icon [icon]="SvgIcon.Web" />
              </app-external-link>
            }

            @for (item of socials(); track item.url) {
              @if (item.code | brandSocialMediaIconByCode | async; as icon) {
                <app-external-link [link]="item.url">
                  <app-brand-social-media-icon [icon]="icon" />
                </app-external-link>
              }
            }
          </div>
        </div>
      </div>
    </div>

    @if (shouldShowEditButton()) {
      <div class="mt-4 flex">
        <p-button
          (onClick)="handleEditClick()"
          appPrimengButton
          size="small"
          label="Edytuj markę" />
      </div>
    }
  </div>

  <div class="order-1 lg:order-2">
    <div [ngClass]="stickyImageCssClass()">
      <div class="aspect-[650/833]">
        @if (isNotNil(illustrationSrc())) {
          <app-image-thumbnail
            [rounded]="false"
            size="full">
            <img
              [alt]="illustrationAlt()"
              [fill]="true"
              [ngSrc]="illustrationSrc()!"
              class="object-contain"
              loading="lazy" />
          </app-image-thumbnail>
        } @else {
          <app-image-thumbnail-unsupported
            [rounded]="false"
            size="full" />
        }
      </div>
    </div>
  </div>
</div>
